import * as Types from '../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type GetGroupedFoldersQueryVariables = Types.Exact<{
  input: Types.GroupedFoldersQueryInput;
}>;


export type GetGroupedFoldersQuery = { __typename?: 'QueryModel', projectFolders: { __typename?: 'ProjectFoldersQueryModel', groupedFolders: Array<{ __typename?: 'GroupedFolder', id: number, name: string, fullPath: string, currentFolderPath: string, targetFolderPath?: string | null, syncStatus: Types.SyncStatus, syncErrorMessage?: string | null }> } };


export const GetGroupedFoldersDocument = gql`
    query GetGroupedFolders($input: GroupedFoldersQueryInput!) {
  projectFolders {
    groupedFolders(input: $input) {
      id
      name
      fullPath
      currentFolderPath
      targetFolderPath
      syncStatus
      syncErrorMessage
    }
  }
}
    `;

/**
 * __useGetGroupedFoldersQuery__
 *
 * To run a query within a React component, call `useGetGroupedFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupedFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupedFoldersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetGroupedFoldersQuery(baseOptions: Apollo.QueryHookOptions<GetGroupedFoldersQuery, GetGroupedFoldersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupedFoldersQuery, GetGroupedFoldersQueryVariables>(GetGroupedFoldersDocument, options);
      }
export function useGetGroupedFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupedFoldersQuery, GetGroupedFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupedFoldersQuery, GetGroupedFoldersQueryVariables>(GetGroupedFoldersDocument, options);
        }
export type GetGroupedFoldersQueryHookResult = ReturnType<typeof useGetGroupedFoldersQuery>;
export type GetGroupedFoldersLazyQueryHookResult = ReturnType<typeof useGetGroupedFoldersLazyQuery>;
export type GetGroupedFoldersQueryResult = Apollo.QueryResult<GetGroupedFoldersQuery, GetGroupedFoldersQueryVariables>;